import styled from 'styled-components';

const StyledBannerConfig = styled.div`
  position: relative;
  background-color: #fff;
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .banner-tech--content{
    position: relative
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .banner-tech--content-col{
    position: relative;
    text-align: right;
  }
  .col--img{
    flex: 0 0 33%;
  }
  .col--img img{
    display: block;
    width: 100%;
  }
  .col--text{
    flex: 0 0 66%;
  }
  h5{
    padding-bottom: 40px;
  }
  .cta--primary p {
    color: ${props => props.theme.colors.green_secondary};
  }
  .overlay--zoom{
    position: fixed;
    width: 100vw;
    height: 100vh;
    transform: translateX(-100%);
    top: 0; 
    left: 0;
    z-index: 10;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .overlay--zoom iframe {
    position: relative;
    top: 0;
    left; 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    border: none;
  }
  .overlay--zoom .close--overlay{
    position: absolute;
    right: 64px;
    top: 40px;
    z-index: 11;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }

  .overlay--zoom .close--overlay img {
    display: block;
    width: 100%;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    h5{
      padding-bottom: 32px;
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .col--img{
      flex: 0 0 41%;
    }
    .col--text{
      flex: 0 0 59%;
    }
    video{
      width: 100%;
    }
  }
  @media screen and (max-width: 767px){
    .banner-tech--content{
      flex-direction: column;
    }
    .col--img{
      flex: 0 0 80%;
      margin: 0 auto 24px;
      width: 80%;
    }
    .col--text{
      flex: 0 0 100%;
      text-align: center;
    }
    h5{
      padding-bottom: 24px;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .overlay--zoom .close--overlay{
      right: 24px;
    }
  }
`;

export {
  StyledBannerConfig,
};

